/**
 * DIPG Donation Amount Selection
 * Handles amount button selection on /about-dipg/ page and passes to /donate page
 */

class DIPGDonate {
    constructor() {
        this.selectedAmount = null;
        this.init();
    }

    init() {
        // Handle amount button selection on DIPG page
        this.setupAmountButtons();
        
        // Handle donate button click
        this.setupDonateButton();
        
        // Prefill form on donate page if amount parameter exists
        this.prefillDonateForm();
    }

    setupAmountButtons() {
        const amountButtons = document.querySelectorAll('.dipg-amount-btn');
        
        amountButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                
                // Remove selected state from all buttons
                amountButtons.forEach(btn => btn.classList.remove('is-selected'));
                
                // Add selected state to clicked button
                button.classList.add('is-selected');
                
                // Store the selected amount
                this.selectedAmount = button.dataset.amount;
            });
        });
    }

    setupDonateButton() {
        const donateButton = document.querySelector('.dipg-donate-btn');
        
        if (donateButton) {
            donateButton.addEventListener('click', (e) => {
                e.preventDefault();
                
                // If an amount is selected, add it to the URL
                const donateUrl = this.selectedAmount 
                    ? `/donate?amount=${this.selectedAmount}`
                    : '/donate';
                
                window.location.href = donateUrl;
            });
        }
    }

    prefillDonateForm() {
        // Check if we're on the donate page with an amount parameter
        const urlParams = new URLSearchParams(window.location.search);
        const amount = urlParams.get('amount');
        
        console.log('DIPG Donate: URL amount parameter:', amount);
        
        if (!amount) return;
        
        // Wait for GiveWP iframe to load
        this.waitForGiveForm(amount);
    }

    waitForGiveForm(amount) {
        console.log('DIPG Donate: Looking for GiveWP iframe...');
        
        let checkAttempts = 0;
        const maxChecks = 50; // 10 seconds max (50 * 200ms)
        
        // Check for iframe and wait for it to be fully loaded
        const checkForIframe = setInterval(() => {
            checkAttempts++;
            const iframe = document.querySelector('iframe[src*="givewp-route=donation-form-view"]');
            
            if (iframe) {
                // Check if iframe is actually loaded and ready
                try {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    
                    if (iframeDoc && iframeDoc.readyState === 'complete') {
                        console.log('DIPG Donate: Found GiveWP iframe and it is fully loaded');
                        clearInterval(checkForIframe);
                        
                        // Iframe is ready, select the amount
                        this.selectAmountInForm(amount, iframe);
                    } else {
                        console.log('DIPG Donate: Found iframe but waiting for it to load... (readyState: ' + (iframeDoc ? iframeDoc.readyState : 'null') + ')');
                    }
                } catch (error) {
                    console.log('DIPG Donate: Found iframe but cannot access contentDocument yet');
                }
            }
            
            // Stop checking after max attempts
            if (checkAttempts >= maxChecks) {
                clearInterval(checkForIframe);
                console.log('DIPG Donate: Timeout reached after', checkAttempts, 'attempts');
            }
        }, 200); // Check every 200ms
    }

    selectAmountInForm(amount, iframe) {
        try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            
            console.log('DIPG Donate: Searching for amount buttons in iframe');
            
            // Find GiveWP amount level buttons
            const amountButtons = iframeDoc.querySelectorAll('.givewp-fields-amount__level');
            
            console.log('DIPG Donate: Found', amountButtons.length, 'amount buttons');
            
            amountButtons.forEach((button, index) => {
                const buttonText = button.textContent;
                console.log(`DIPG Donate: Button ${index}: text="${buttonText}"`);
                
                // Compare amounts (handle different formats like "$250.00" vs "250")
                const buttonAmount = parseFloat(buttonText.replace(/[$,]/g, ''));
                if (buttonAmount === parseFloat(amount)) {
                    console.log('DIPG Donate: Found matching button, clicking it');
                    button.click();
                }
            });
            
            console.log('DIPG Donate: Amount selection completed');
        } catch (error) {
            console.error('Could not prefill donation amount:', error);
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new DIPGDonate());
} else {
    new DIPGDonate();
}

export default DIPGDonate;

